import React, { Component } from "react";
import _ from "lodash";

import UserTable from "./UserTable";
import ManageModal from "./ManageModal";
import ConfirmModal from "../../components/Modals/Confirm";

import UsersAPI from "../../api/users";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      username: "",
      isAdmin: false,
      showModal: false,
      showConfirmModal: false,
      selectedUserID: 0
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers = () => {
    UsersAPI.getUsers().then(result => this.setState({ users: result.data }));
  };

  toggleModal = () => {
    const { showModal } = this.state;
    if (showModal) {
      this.setState({
        username: "",
        idAdmin: false,
        selectedUserID: ""
      });
    }
    this.setState({ showModal: !showModal });
  };

  onChange = e => {
    this.setState({ username: e.target.value });
  };

  toggleIsAdmin = e => {
    this.setState({ isAdmin: e.target.checked });
  };

  onSubmit = e => {
    const { selectedUserID, username, isAdmin } = this.state;
    const formData = {
      id: selectedUserID,
      username,
      isAdmin
    };

    this.toggleModal();

    if (!selectedUserID) {
      UsersAPI.addUser(formData).then(() => this.getUsers());
    } else {
      UsersAPI.updateUser(formData).then(() => this.getUsers());
    }
  };

  toggleConfirmModal = (id = "") => {
    const { showConfirmModal } = this.state;
    this.setState({
      showConfirmModal: !showConfirmModal,
      selectedUserID: id
    });
  };

  deleteUser = () => {
    const { selectedUserID } = this.state;
    UsersAPI.deleteUser(selectedUserID).then(() => {
      this.getUsers();
      this.toggleConfirmModal();
    });
  };

  selectUser = id => {
    const { users } = this.state;
    const user = _.find(users, u => u.usr_id === id);

    this.setState({
      username: user.usr_username,
      isAdmin: user.usr_isAdmin,
      selectedUserID: user.usr_id,
      showModal: true
    });
  };

  render() {
    const {
      users,
      showModal,
      username,
      isAdmin,
      showConfirmModal
    } = this.state;

    return (
      <div>
        <ConfirmModal
          show={showConfirmModal}
          title="Confirm Delete"
          toggle={this.toggleConfirmModal}
          confirm={this.deleteUser}
        >
          Are you sure you want to delete this user?
        </ConfirmModal>

        <ManageModal
          username={username}
          isAdmin={isAdmin}
          show={showModal}
          onHide={this.toggleModal}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          toggleIsAdmin={this.toggleIsAdmin}
        />

        <p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.toggleModal}
          >
            <i className="fa fa-plus-circle" /> Add User
          </button>
        </p>

        <div className="row">
          <div className="col-md-6">
            <UserTable
              users={users}
              deleteUser={this.toggleConfirmModal}
              selectUser={this.selectUser}
            />
          </div>
          <div className="col-md-5">
            <div className="alert alert-info">
              <i className="fa fa-exclamation-triangle" /> Usernames must match
              their ACPS username. Those with 'Admin' access are able to manage
              user accounts and tags.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/pages/Users/index.jsx